import { ArrowLeft, Loader2 } from "lucide-react";
// This blue button has fixed width
export function Button({ onClick, disabled, children }: { onClick: any, children: any, disabled?: any }) {
    return (
        <button onClick={onClick}
            className={`py-1.5 w-24 rounded shadow-md transition-all duration-300 ease-in-out 
                text-xs font-medium
        ${disabled
                    ? 'bg-gray-200 cursor-not-allowed text-gray-600'
                    : 'bg-gradient-to-r from-blue-600 to-blue-500 text-white hover:from-blue-700 hover:to-blue-600 active:shadow-inner'
                }
            
        `}
            disabled={disabled}>
            {children}
        </button>
    )
}

export function Button2({ onClick, children, disabled }: { onClick: any, children: any, disabled?: any }) {
    return (
        <button 
            onClick={onClick} 
            disabled={disabled}
            className={`text-xs border border-gray-300 bg-white shadow-lg shadow-gray-200 py-1.5 px-4 rounded-md ${
                disabled 
                    ? 'text-gray-400 cursor-not-allowed bg-gray-50' 
                    : 'text-gray-600 hover:bg-gray-100'
            }`}
        >
            {children}
        </button>
    )
}

// This blue button has dynamic width
export function BlueButton({ onClick, disabled, children }: {
    onClick: any, children: any,
    disabled?: any
}) {
    return (
        <button onClick={onClick}
            className={`py-1 px-2 rounded-md shadow-md transition-all duration-300 ease-in-out 
                text-xs bg-gradient-to-r from-blue-600 to-blue-500 text-white 
                hover:from-blue-700 hover:to-blue-600 active:shadow-inner`}
            disabled={disabled}>
            {children}
        </button>
    )
}

export function SmallButton({ onClick, children }: { onClick: any, children: any }) {
    return (
        <button onClick={onClick} className="text-xs shadow shadow-gray-200 py-1.5 px-3 
        text-gray-600 border rounded-md hover:bg-gray-100  ">
            {children}
        </button>
    )
}

export function TerminalButton({ processing, onClick, children }: {
    processing: boolean, onClick: any,
    children: any
}) {
    return (
        <button
            disabled={processing}
            onClick={onClick}
            className={`text-xs font-medium mt-4 w-full bg-gradient-to-r from-blue-600 to-blue-500  text-white py-2 px-4 rounded-md ${!processing && "hover:bg-blue-700"}
                                        focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors 
                                        duration-300`}>
            {processing ? <Loader2 className="w-4 h-4 animate-spin mx-auto" /> : children}
        </button>
    )
}

export function TerminalButton2({ onClick, children }: {
    onClick: any,
    children: any
}) {
    return (
        <button
            onClick={onClick}
            className="text-xs font-medium mt-2 w-full text-gray-500 hover:text-gray-700 py-2 px-4 rounded-md
                                border border-gray-500 hover:bg-gray-200
                               transition-colors 
                                duration-300">
            {children}
        </button>
    )
}

export function TerminalButton3({ onClick, children, selected }: {
    onClick: any,
    children: any,
    selected: boolean
}) {
    return (
        <div onClick={onClick} className={"flex flex-col items-center shadow-md py-1 rounded-lg w-28 border  cursor-pointer " +
            (selected ? "border-blue-500 shadow-blue-200" : "shadow-gray-300 hover:shadow-gray-400 border-gray-200")} >
            {children}
        </div>
    )
}

// Alias for TerminalButton3 for backward compatibility
export const Button3 = TerminalButton3;

export function BackButton({ onClick }: { onClick: any}) {
    return (
        <button onClick={onClick}
            className={`py-1 px-2 border border-blue-400 hover:border-blue-500 mb-3 w-20 flex items-center rounded-md
                text-xxs text-blue-500
        `}>
            <ArrowLeft className="w-5 h-5 mr-1" />Back
        </button>
    )
}